import type { ApiCourse } from '@attensi/v3-client-wip/dist/esm/__admin__prod__/generated'
import type { EventWithIncluded } from '../types/eventTypes'
import { eventMock, mockCourses } from './eventDataMocks'

const returnError = { data: { type: 'Error' } }

export const getEventMock = (): EventWithIncluded => {
  return eventMock
}

export const getCourseMock = (courseId: number): ApiCourse => {
  const course = mockCourses.find(
    (course) => course.data?.id === courseId.toString()
  )

  return course ?? returnError
}
